// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e391ed38","770":"e3c36a87"}[chunkId] + ".chunk.js";
};